// The version types of part_finder_attribute_version. The history lists the draft (if any) above
// the published versions.
export enum AttributeVersionType {
  DRAFT = 'draft',
  INACTIVE = 'inactive',
  RELEASE = 'release',
}
